{
  "agent": {
    "title": "Assistant"
  },
  "aura": {
    "label": "powered by AURA",
    "learnMore": "AURA is Mezmo's open-source harness for <br> production-ready agents. <a href='https://www.mezmo.com/aura' target='_blank' rel='noopener noreferrer'>Learn more</a>"
  },
  "feedback": {
    "title": "AI Feedback",
    "wasThisHelpful": "Was this helpful?",
    "notHelpful": "We are sorry that this was not helpful. Would you like to provide details as to what went wrong?",
    "helpful": "Thank you for letting us know that this was helpful!",
    "feedback": "Feedback",
    "positiveFeedback": "Positive Feedback",
    "negativeFeedback": "Negative Feedback"
  }
}